import { render } from "./PagesPage.vue?vue&type=template&id=0b7d4f78"
import script from "./PagesPage.vue?vue&type=script&lang=js"
export * from "./PagesPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__